const WixUrl = () => import(/* webpackChunkName: "WixUrl" */ '@/components/Pages/IframeUrl')
const Home = () => import(/* webpackChunkName: "SectionHome" */ '@/components/Base/SectionHome')
const IsefCategories = () => import(/* webpackChunkName: "IsefCategories" */ '@/components/Pages/IsefCategories')

const store = require('@/store').default

module.exports = [
  {
    path: '/:partner?/categories',
    name: 'isefCategories',
    component: IsefCategories
  },
  {
    path: '/:partner?/:fairSlug',
    name: 'exploreFair',
    component: Home,
    beforeEnter: function (to, from, next) {
      if (to.params.fairSlug !== 'undefined') {
        store.dispatch('setPage', to.params.fairSlug)
        store.dispatch('getFairForEvent', store.getters.currentPage).then(() => {
          next()
        }).catch(err => {
          console.error(err)
          store.dispatch('getIframeBySlug', `/${to.params.fairSlug}`).then(iframe => {
            next({ name: 'iframe', params: { iframeSlug: iframe.route.replace(/^\/+/, '') } })
          }).catch(err => {
            console.error(err)
            next({ name: 'notFound' })
          })
        })
      }
    }
  },
  {
    path: '/:partner?/:iframeSlug',
    name: 'iframe',
    component: WixUrl
  }
]
